import { createFileRoute } from '@tanstack/react-router'
import { QueryGuard } from '../../../components/query-guard'
import { ProfileView } from '../../../features/profile/components/profile-view'
import { useUserByIdQuery } from '../../../hooks/api'

export const Route = createFileRoute('/_protected/users/$id')({
  component: UserByIdPage,
})

function UserByIdPage() {
  const { id } = Route.useParams()
  const userQuery = useUserByIdQuery(id)

  return (
    <QueryGuard query={userQuery} errorMessage="Failed to load user">
      {(user, permissions) => <ProfileView user={user} canEdit={permissions?.canEdit ?? false} />}
    </QueryGuard>
  )
}
